<section class="page">
  <a class="back" routerLink="/">← Back to estimates</a>

  <div class="card">
    <p class="eyebrow">Account</p>
    <h1>Change password</h1>
    <p class="subtitle">
      Replace the temporary password you were emailed with one only you know.
    </p>

    @if (error(); as message) {
      <div class="banner error" role="alert">{{ message }}</div>
    }
    @if (success(); as message) {
      <div class="banner success" role="status">{{ message }}</div>
    }

    <form (ngSubmit)="submit()">
      <label class="field">
        <span class="field-label">Current password</span>
        <input
          type="password"
          name="currentPassword"
          [(ngModel)]="currentPassword"
          autocomplete="current-password"
          [disabled]="saving()"
          required
        />
      </label>

      <label class="field">
        <span class="field-label">New password</span>
        <input
          type="password"
          name="newPassword"
          [(ngModel)]="newPassword"
          autocomplete="new-password"
          [disabled]="saving()"
          required
        />
        <span class="hint">
          8+ characters with an uppercase letter, a lowercase letter, a number,
          and a symbol.
        </span>
      </label>

      <label class="field">
        <span class="field-label">Confirm new password</span>
        <input
          type="password"
          name="confirmPassword"
          [(ngModel)]="confirmPassword"
          autocomplete="new-password"
          [disabled]="saving()"
          required
        />
      </label>

      <button type="submit" class="submit-btn" [disabled]="saving()">
        {{ saving() ? "Updating…" : "Update password" }}
      </button>
    </form>
  </div>
</section>
